import { Component, OnInit } from '@angular/core';
import { DocumentsService } from '../../../services/documents.service';
import { Globals } from 'projects/core/src/globals';

@Component({
  selector: 'app-allinvoices',
  templateUrl: './allinvoices.component.html',
  styleUrls: ['./allinvoices.component.css']
})

export class AllinvoicesComponent implements OnInit {
  
  list=[];

  date_search=new Date().toMysqlDate();

  constructor(
    private documentsService:DocumentsService
  ) { }

  ngOnInit(): void {
    this.getList();
  }


  getList(){
    Globals.setLoading(true);
    this.documentsService.verifyAllInvoice(this.date_search).subscribe((items)=>{
      this.list=items;
      Globals.setLoading(false);
    });
  }
  

  moveSearch(days){
    let d=new Date(this.date_search)
    d.setDate( d.getDate() + days );
    if (d > new Date()) d=new Date();
    this.date_search=d.toMysqlDate();
    this.getList()
  }
  

  viewButtonSearch(){
    let d=new Date(this.date_search).setHours(0, 0, 0, 0);
    let now=new Date().setHours(0, 0, 0, 0);
    console.log(d);
    console.log(now);
    if (d >= now)
      return false;
    else
      return true;    
  }


  cancel(){
    this['modalWindow'].close();
  }

}
